export default __webpack_public_path__ + "static/media/show-perfume-2.9eb7eb0e.webp";